import React from "react";
import MainSettings from "../Component/Settings";

const Settings = () => {
	return <MainSettings />;
};

export default Settings;
